import styled from 'styled-components';
import { baseVariables, contextualVariable, toRem } from '@marriott/mi-ui-library';

export const StyledContactUsFooter = styled.div`
  background-color: ${baseVariables.color['base10']};

  .mt-copyright-component__copyright-text {
    margin: unset;
  }

  #teconsent, #ccpalink {
    a {
      font: normal normal ${baseVariables.font.fontWeightRegular} ${baseVariables.font.fontS} /
        ${baseVariables.font.fontXl} ${baseVariables.font.fontSwiss} !important;
      font-size: ${toRem(12)} !important;
      max-height: ${toRem(16)} !important;
      display: block !important; // Normalize text spacing when line wraps.
      color: inherit;
      padding: 0;
      text-decoration: underline;
      text-underline-offset: ${toRem(3)};
      &:hover {
        background: none !important;
        color: ${contextualVariable.linkTextColor} !important;
      }
      .icon-arrow-right {
        color: ${contextualVariable.brandFgColor};
      }
      &:hover {
        color: ${contextualVariable.linkTextColor};
      }
    }
  }


  #teconsent {
    .mt-multi-link__link:hover {
      color: ${contextualVariable.accentColor};
    }
    a{
      margin-top: ${toRem(4)} !important;
      border: none !important;
    }
  }
  #ccpalink {
    .mt-multi-link__link {
      display: flex;
      margin-top: ${toRem(4)} !important;
      &:hover {
        color: ${contextualVariable.accentColor};
      }
      a {
        margin-top: 0 !important;

      }
      img {
        margin-left: unset !important;
        align-self: center;
        margin-top: ${toRem(3)} !important;
      }
    }
  }
    .container .luxury-header-text-cta {
      padding: ${toRem(64)} 0;
    }
    .mt-social {
      border-top: ${toRem(1)} ${baseVariables.border.borderStyleDefault} ${baseVariables.color['neutral20']};
      .mt-social__icons {
        [dir='rtl'] & {
          padding-right: ${toRem(24)};
          margin: ${toRem(2)} 0 ${toRem(22)} auto;
        }
      }
      @media only ${baseVariables.mediaQuery.md} {
        .mt-social__icons li {
          [dir='rtl'] & {
            margin-right: 0 !important;
          }
        }
      }
    }
    .row {
      padding: ${toRem(27)} 0;
      margin: 0;
    }
    .mt-copyright-component {
      padding: 0;
      border: 0;
    }
    .dark-theme .mt-copyright-component__copyright {
        border-top: ${toRem(1)} ${baseVariables.border.borderStyleDefault} ${baseVariables.color['neutral20']};
        justify-content: space-between;
    }
    .icon-phone,
    .icon-mail {
      color: ${contextualVariable.accentColor};
    }
  }

  .language-selector-button-footer {
    h4.header-heading {
      color: ${baseVariables.color['base10']} !important;
      cursor: default;
    }

    a.language-selector-button {
      cursor: pointer;
      display: flex !important;
      align-items: center;

      &:hover {
        font-weight: 500 !important;
      }
    }
  }
`;

export const StyledFooter = styled.div`
  .footer-link {
    margin: 0;
    border-bottom: ${toRem(1)} solid ${contextualVariable.brandFgColor};
    &:hover {
      border-bottom: ${toRem(1)} solid ${contextualVariable.linkTextColor} !important;
    }
  }

  .m-nav-link {
    padding: 0;
    border: 0;
    &:hover {
      cursor: pointer;
      border-bottom: 0;
      font-weight: 400;
      text-decoration: underline;
    }
  }
  .copyright {
    font-size: ${toRem(12)};
    font-weight: 400;
    line-height: ${toRem(16)};
    a {
      font-weight: 400;
      text-decoration: underline;
    }
  }
  .footer-bottom-link-list {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .hidden {
    display: none;
  }
  .icon-arrow-right {
    margin-right: ${toRem(4)};
    margin-left: ${toRem(4)};
    &::before {
      position: relative;
      top: 0;
      transform: translateY(10%);
    }
  }
`;
